import type { EmailTrackingApi } from "../../api/EmailTrackingApi";
import type { EmailDeliveryResult } from "../../generated/dto/EmailDeliveryResult";
import type { EmailTrackingRef } from "../../generated/dto/EmailTrackingRef";

export class EmailTrackingFrontendService {
  constructor(private readonly api: EmailTrackingApi) {}
  async retryPendingEmailsStaff(): Promise<number> {
    return this.api.retryPendingEmailsStaff()
  }
  async sendTrackedEmailStaff(email: EmailTrackingRef): Promise<EmailDeliveryResult> {
    return this.api.sendTrackedEmailStaff(email)
  }
}
